import type { Language } from '../../types/document'
import type { LanguagePack } from './types'
import { hi } from './hi'
import { en } from './en'
import { bn } from './bn'
import { mr } from './mr'
import { ta } from './ta'
import { te } from './te'
import { gu } from './gu'
import { kn } from './kn'
import { ml } from './ml'
import { pa } from './pa'
import { or } from './or'
import { asm } from './as'

export type { LanguagePack } from './types'

// All packs are bundled (≈25 KB gzipped) so every language works offline.
const PACKS: Record<Language, LanguagePack> = { hi, en, bn, mr, ta, te, gu, kn, ml, pa, or, as: asm }

export function pack(language: Language): LanguagePack {
  return PACKS[language] ?? hi
}
